<template>
  <div>
    <header :class="customHeader" class="flex items-center cursor-pointer" @click.prevent="toggle">
        <div class="mr-2">
          <el-switch v-model="active" @change="toggle" :disabled="disabled" />
        </div>
        <slot name="headerRight"/>
    </header>
    <transition
      name="collapsible"
      @enter="startTransition"
      @after-enter="endTransition"
      @before-leave="startTransition"
      @after-leave="endTransition"
    >
      <section v-if="active" :class="overflowHidden ? 'overflow-hidden' : ''">
        <div :class="customContent">
            <slot name="content" />
        </div>
      </section>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'base-collapsible-switch',
  props: {
    value: Boolean,
    customHeader: {
      type: String,
      default: ''
    },
    customContent: {
      type: String,
      default: ''
    },
    overflowHidden: {
      type: Boolean,
      default: true,
    }
  },
  data: function () {
    return {
      active: false,
      disabled: false,
    }
  },
  computed: {
    hasContent: function () {
      return this.$scopedSlots.headerLeft
    }
  },
  watch: {
    active: function (value, oldValue) {
      if (value !== oldValue) {
        this.$emit('input', value)
        if (!value) {
          this.$emit('clearForm')
        }
      }
    },
    value: {
      immediate: true,
      handler: function (value, oldValue) {
        if (value !== oldValue) {
          this.active = value
        }
      }
    },
  },
  methods: {
    toggle () {
      if (!this.disabled) this.active = !this.active
    },
    startTransition (el) {
      el.style.height = el.scrollHeight + 'px'
    },
    endTransition (el) {
      el.style.height = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.collapsible-enter-active,
.collapsible-leave-active {
  will-change: height;
  transition: height 0.2s ease;
}
.collapsible-enter,
.collapsible-leave-to {
  height: 0 !important;
}
</style>
